import React from 'react'
import { Marker, Circle } from 'react-leaflet'

/**
 * One location on the map.
 *
 * Renders the accuracy circle instead of a pin when the point is selected and its reported
 * accuracy is poor (> 50 m); otherwise a marker with the given icon. Clicking a marker scrolls
 * the side list to the matching row and selects the location.
 */
const LocationMarker = React.memo((props) => {

    const { location, selected, handleSelect, scrollYContainerRef, scrollXContainerRef, icon, iconColor } = props

    if (selected && location.accuracy && location.accuracy > 50) {
        return (
            <Circle
                center={[location.lat, location.lng]}
                radius={location.accuracy}
                color={iconColor ? iconColor : "blue"}
                fillOpacity={0.4}
            />
        )
    }

    return (
        <Marker
            icon={icon}
            position={[location.lat, location.lng]}
            locationId={location.id} // stored in marker.options; lets the cluster icon know it holds the selection
            eventHandlers={{
                click: () => {
                    const elem = document.getElementById(`menu-custom-list-item-${location.id}`);
                    if (scrollYContainerRef && scrollYContainerRef.current && elem && elem.offsetTop) {
                        scrollYContainerRef.current.scrollTop = elem.offsetTop
                    }

                    if (scrollXContainerRef && scrollXContainerRef.current && elem && elem.offsetTop) {
                        // Center the element horizontally
                        const scrollPosition =
                            elem.offsetLeft - scrollXContainerRef.current.offsetWidth / 2 + elem.offsetWidth / 2;

                        scrollXContainerRef.current.scrollLeft = scrollPosition;
                    }
                    handleSelect(location)
                },
            }}
        />
    )
})

export default LocationMarker
